import { FormItem } from "../../infinity-item/interfaces/FormItem.interface";

/**
 * [Pure]
 * @param initial 
 * @param item 
 */
export function sumReducer(initial: number, item: FormItem): number {
    return initial + (parseInt(item.value) || 0);
}
